import { sendRequestProtocols } from '../axios';

export default {
    state: {
        processing: false,
        error: null,
        debug: true,
    },
    mutations: {
        SET_DEBUG(state, payload) {
            state.debug = payload
        },
        SET_PROCESSING(state,payload) {
            state.processing = payload
        },
        SET_ERROR(state,payload) {
            state.error = payload
        },
        CLEAN_ERROR(state) {
            state.error = null
        }
    },
    actions: {
      async SEND_STATISTIC(){
        const data = await sendRequestProtocols(`sendStatistic`)
        return data
      },
    },
    getters: {
        getProcessing: (state) =>state.processing,
        getError: (state) => state.error,
        getDebug: (state) => state.debug
    }
}
